"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var osa = require("@wk/osa");
/**
 * @copyright
 * Copyright (c) 2003-2022 Wolters Kluwer Technology B.V. and/or its affiliates. All Rights Reserved.
 *
 * This source code (the "Software") is the confidential and proprietary information of
 * Wolters Kluwer Technology BV and/or its affiliates. The Software contains trade secret information,
 * and you may not reverse-engineer, decompile, disclose, copy, modify, upload, download, transmit,
 * republish, or otherwise misappropriate the Software without the express written approval of
 * Wolters Kluwer Technology BV and/or its affiliates. In addition, the Software is protected by U.S.
 * and other applicable copyright laws. The Software is provided solely for the purpose of technical
 * analysis within the scope of a single project, subject to applicable license requirements set forth
 * by Wolters Kluwer Technology BV and/or its affiliates. All copies of this Software must be destroyed
 * or otherwise removed from your system and any associated hardware when any applicable license terminates
 * or expires.
 */
var common;
(function (common) {
    osa.attachDomain(common, 'Common', '3.4.11');
})(common || (common = {}));
(function (common) {
    /**
    * Enum AuthenticationType
    *
    *
    */
    var AuthenticationType;
    (function (AuthenticationType) {
        AuthenticationType[AuthenticationType["IdAndPassword"] = 0] = "IdAndPassword"; /* = 'IdAndPassword'*/
        AuthenticationType[AuthenticationType["IP"] = 1] = "IP"; /* = 'IP'*/
        AuthenticationType[AuthenticationType["Referrer"] = 2] = "Referrer"; /* = 'Referrer'*/
        AuthenticationType[AuthenticationType["TrustedSecurityToken"] = 3] = "TrustedSecurityToken"; /* = 'TrustedSecurityToken'*/
        AuthenticationType[AuthenticationType["Anonymous"] = 4] = "Anonymous"; /* = 'Anonymous'*/
        AuthenticationType[AuthenticationType["IdOnly"] = 5] = "IdOnly"; /* = 'IdOnly'*/
        AuthenticationType[AuthenticationType["Unknown"] = 6] = "Unknown"; /* = 'Unknown'*/
    })(AuthenticationType = common.AuthenticationType || (common.AuthenticationType = {}));
})(common || (common = {}));
(function (common) {
    /**
    * Enum Color
    *
    *
    */
    var Color;
    (function (Color) {
        Color[Color["Pink"] = 0] = "Pink"; /* = 'Pink'*/
        Color[Color["Orange"] = 1] = "Orange"; /* = 'Orange'*/
        Color[Color["Yellow"] = 2] = "Yellow"; /* = 'Yellow'*/
        Color[Color["Green"] = 3] = "Green"; /* = 'Green'*/
        Color[Color["Blue"] = 4] = "Blue"; /* = 'Blue'*/
        Color[Color["None"] = 5] = "None"; /* = 'None'*/
    })(Color = common.Color || (common.Color = {}));
})(common || (common = {}));
(function (common) {
    /**
    * Enum DateOperator
    *
    *
    */
    var DateOperator;
    (function (DateOperator) {
        DateOperator[DateOperator["Before"] = 0] = "Before"; /* = 'Before'*/
        DateOperator[DateOperator["After"] = 1] = "After"; /* = 'After'*/
        DateOperator[DateOperator["Between"] = 2] = "Between"; /* = 'Between'*/
        DateOperator[DateOperator["On"] = 3] = "On"; /* = 'On'*/
    })(DateOperator = common.DateOperator || (common.DateOperator = {}));
})(common || (common = {}));
(function (common) {
    /**
    * Enum DayOfWeek
    *
    *
    */
    var DayOfWeek;
    (function (DayOfWeek) {
        DayOfWeek[DayOfWeek["Monday"] = 0] = "Monday"; /* = 'Monday'*/
        DayOfWeek[DayOfWeek["Tuesday"] = 1] = "Tuesday"; /* = 'Tuesday'*/
        DayOfWeek[DayOfWeek["Wednesday"] = 2] = "Wednesday"; /* = 'Wednesday'*/
        DayOfWeek[DayOfWeek["Thursday"] = 3] = "Thursday"; /* = 'Thursday'*/
        DayOfWeek[DayOfWeek["Friday"] = 4] = "Friday"; /* = 'Friday'*/
        DayOfWeek[DayOfWeek["Saturday"] = 5] = "Saturday"; /* = 'Saturday'*/
        DayOfWeek[DayOfWeek["Sunday"] = 6] = "Sunday"; /* = 'Sunday'*/
    })(DayOfWeek = common.DayOfWeek || (common.DayOfWeek = {}));
})(common || (common = {}));
(function (common) {
    /**
    * Enum EventFrequency
    *
    *
    */
    var EventFrequency;
    (function (EventFrequency) {
        EventFrequency[EventFrequency["BusinessDays"] = 0] = "BusinessDays"; /* = 'BusinessDays'*/
        EventFrequency[EventFrequency["Daily"] = 1] = "Daily"; /* = 'Daily'*/
        EventFrequency[EventFrequency["Weekly"] = 2] = "Weekly"; /* = 'Weekly'*/
        EventFrequency[EventFrequency["Monthly"] = 3] = "Monthly"; /* = 'Monthly'*/
        EventFrequency[EventFrequency["Biweekly"] = 4] = "Biweekly"; /* = 'Biweekly'*/
        EventFrequency[EventFrequency["Immediate"] = 5] = "Immediate"; /* = 'Immediate'*/
        EventFrequency[EventFrequency["Delay"] = 6] = "Delay"; /* = 'Delay'*/
        EventFrequency[EventFrequency["ContentTrigger"] = 7] = "ContentTrigger"; /* = 'ContentTrigger'*/
    })(EventFrequency = common.EventFrequency || (common.EventFrequency = {}));
})(common || (common = {}));
(function (common) {
    /**
    * Enum PitContextSearchRule
    *
    *
    */
    var PitContextSearchRule;
    (function (PitContextSearchRule) {
        PitContextSearchRule[PitContextSearchRule["NoRule"] = 0] = "NoRule"; /* = 'NoRule'*/
        PitContextSearchRule[PitContextSearchRule["UseCurrent"] = 1] = "UseCurrent"; /* = 'UseCurrent'*/
        PitContextSearchRule[PitContextSearchRule["UseOriginal"] = 2] = "UseOriginal"; /* = 'UseOriginal'*/
    })(PitContextSearchRule = common.PitContextSearchRule || (common.PitContextSearchRule = {}));
})(common || (common = {}));
(function (common) {
    /**
    * Enum SubscriptionLevel
    *
    *
    */
    var SubscriptionLevel;
    (function (SubscriptionLevel) {
        SubscriptionLevel[SubscriptionLevel["Subscribed"] = 0] = "Subscribed"; /* = 'Subscribed'*/
        SubscriptionLevel[SubscriptionLevel["Unsubscribed"] = 1] = "Unsubscribed"; /* = 'Unsubscribed'*/
        SubscriptionLevel[SubscriptionLevel["All"] = 2] = "All"; /* = 'All'*/
    })(SubscriptionLevel = common.SubscriptionLevel || (common.SubscriptionLevel = {}));
})(common || (common = {}));
(function (common) {
    /**
    * Enum TimeUnit
    *
    *
    */
    var TimeUnit;
    (function (TimeUnit) {
        TimeUnit[TimeUnit["Minute"] = 0] = "Minute"; /* = 'Minute'*/
        TimeUnit[TimeUnit["Hour"] = 1] = "Hour"; /* = 'Hour'*/
        TimeUnit[TimeUnit["Day"] = 2] = "Day"; /* = 'Day'*/
        TimeUnit[TimeUnit["Week"] = 3] = "Week"; /* = 'Week'*/
    })(TimeUnit = common.TimeUnit || (common.TimeUnit = {}));
})(common || (common = {}));
(function (common) {
    /**
    * Enum Units
    *
    *
    */
    var Units;
    (function (Units) {
        Units[Units["Usd"] = 0] = "Usd"; /* = 'Usd'*/
        Units[Units["Eur"] = 1] = "Eur"; /* = 'Eur'*/
        Units[Units["Tokens"] = 2] = "Tokens"; /* = 'Tokens'*/
        Units[Units["Units"] = 3] = "Units"; /* = 'Units'*/
        Units[Units["Minutes"] = 4] = "Minutes"; /* = 'Minutes'*/
        Units[Units["Seconds"] = 5] = "Seconds"; /* = 'Seconds'*/
        Units[Units["GB"] = 6] = "GB"; /* = 'GB'*/
        Units[Units["MB"] = 7] = "MB"; /* = 'MB'*/
        Units[Units["KB"] = 8] = "KB"; /* = 'KB'*/
        Units[Units["Downloads"] = 9] = "Downloads"; /* = 'Downloads'*/
        Units[Units["Transactions"] = 10] = "Transactions"; /* = 'Transactions'*/
    })(Units = common.Units || (common.Units = {}));
})(common || (common = {}));
(function (common) {
    /**
    * Enum VersionOperator
    *
    *
    */
    var VersionOperator;
    (function (VersionOperator) {
        VersionOperator[VersionOperator["Maximum"] = 0] = "Maximum"; /* = 'Maximum'*/
        VersionOperator[VersionOperator["Minimum"] = 1] = "Minimum"; /* = 'Minimum'*/
        VersionOperator[VersionOperator["Between"] = 2] = "Between"; /* = 'Between'*/
        VersionOperator[VersionOperator["Exact"] = 3] = "Exact"; /* = 'Exact'*/
    })(VersionOperator = common.VersionOperator || (common.VersionOperator = {}));
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var ResponseInfoCache = /** @class */ (function (_super) {
            __extends(ResponseInfoCache, _super);
            /**
            *
            * @param data - an initial data
            */
            function ResponseInfoCache(data) {
                return _super.call(this, data) || this;
            }
            ResponseInfoCache = __decorate([
                osa.decorators.ComplexType(common, 'common.message.ResponseInfoCache', {
                    'Versions': { n: 'versions', r: 'common.message.CacheContainerVersionList', r2: function () { return common.message.CacheContainerVersionList; }, f: 5 }
                })
            ], ResponseInfoCache);
            return ResponseInfoCache;
        }(osa.base.Complex));
        message.ResponseInfoCache = ResponseInfoCache;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var RestrictionPathItem = /** @class */ (function (_super) {
            __extends(RestrictionPathItem, _super);
            /**
            *
            * @param data - an initial data
            */
            function RestrictionPathItem(data) {
                return _super.call(this, data) || this;
            }
            RestrictionPathItem = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.RestrictionPathItem', {
                    'Name': { n: 'name', t: 2 },
                    'Namespace': { n: 'namespace', t: 2 },
                    'TypeName': { n: 'typeName', t: 2 },
                    'TypeNamespace': { n: 'typeNamespace', t: 2 }
                })
            ], RestrictionPathItem);
            return RestrictionPathItem;
        }(osa.base.Complex));
        capabilities.RestrictionPathItem = RestrictionPathItem;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var Restriction = /** @class */ (function (_super) {
            __extends(Restriction, _super);
            /**
            *
            * @param data - an initial data
            */
            function Restriction(data) {
                var _this = _super.call(this, data) || this;
                osa.base.checkInstanceCreate(_this, Restriction_1);
                return _this;
            }
            Restriction_1 = Restriction;
            var Restriction_1;
            Restriction = Restriction_1 = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.Restriction', {})
            ], Restriction);
            return Restriction;
        }(osa.base.Complex));
        capabilities.Restriction = Restriction;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var AbstractId = /** @class */ (function (_super) {
        __extends(AbstractId, _super);
        /**
        *
        * @param data - an initial data
        */
        function AbstractId(data) {
            var _this = _super.call(this, data) || this;
            osa.base.checkInstanceCreate(_this, AbstractId_1);
            return _this;
        }
        AbstractId_1 = AbstractId;
        var AbstractId_1;
        AbstractId = AbstractId_1 = __decorate([
            osa.decorators.ComplexType(common, 'common.AbstractId', {
                'Id': { n: 'id', t: 2 }
            })
        ], AbstractId);
        return AbstractId;
    }(osa.base.Complex));
    common.AbstractId = AbstractId;
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var RequestCapabilities = /** @class */ (function (_super) {
            __extends(RequestCapabilities, _super);
            /**
            *
            * @param data - an initial data
            */
            function RequestCapabilities(data) {
                return _super.call(this, data) || this;
            }
            RequestCapabilities = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.RequestCapabilities', {
                    'AuthenticatedUserRequired': { n: 'authenticatedUserRequired', t: 1 }
                })
            ], RequestCapabilities);
            return RequestCapabilities;
        }(osa.base.Complex));
        capabilities.RequestCapabilities = RequestCapabilities;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var Address = /** @class */ (function (_super) {
        __extends(Address, _super);
        /**
        *
        * @param data - an initial data
        */
        function Address(data) {
            return _super.call(this, data) || this;
        }
        Address = __decorate([
            osa.decorators.ComplexType(common, 'common.Address', {
                'AddressLine': { n: 'addressLine', t: 2, f: 4 },
                'PostalCode': { n: 'postalCode', t: 2 },
                'PoBox': { n: 'poBox', t: 2 },
                'City': { n: 'city', t: 2 },
                'State': { n: 'state', t: 2 },
                'CountryCode': { n: 'countryCode', t: 2 },
                'Telephone': { n: 'telephone', t: 2 },
                'Email': { n: 'email', t: 2 }
            })
        ], Address);
        return Address;
    }(osa.base.Complex));
    common.Address = Address;
})(common || (common = {}));
(function (common) {
    var Amount = /** @class */ (function (_super) {
        __extends(Amount, _super);
        /**
        *
        * @param data - an initial data
        */
        function Amount(data) {
            return _super.call(this, data) || this;
        }
        Amount = __decorate([
            osa.decorators.ComplexType(common, 'common.Amount', {
                'Quantity': { n: 'quantity', t: 5 },
                'Unit': { n: 'unit', t: 4, r2: function () { return common.Units; } }
            })
        ], Amount);
        return Amount;
    }(osa.base.Complex));
    common.Amount = Amount;
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var DiagnosticsServiceCapabilities = /** @class */ (function (_super) {
            __extends(DiagnosticsServiceCapabilities, _super);
            /**
            *
            * @param data - an initial data
            */
            function DiagnosticsServiceCapabilities(data) {
                return _super.call(this, data) || this;
            }
            DiagnosticsServiceCapabilities = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.DiagnosticsServiceCapabilities', {
                    'ImplementationVersion': { n: 'implementationVersion', t: 2 }
                })
            ], DiagnosticsServiceCapabilities);
            return DiagnosticsServiceCapabilities;
        }(osa.base.Complex));
        capabilities.DiagnosticsServiceCapabilities = DiagnosticsServiceCapabilities;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var Credentials = /** @class */ (function (_super) {
        __extends(Credentials, _super);
        /**
        *
        * @param data - an initial data
        */
        function Credentials(data) {
            return _super.call(this, data) || this;
        }
        Credentials = __decorate([
            osa.decorators.ComplexType(common, 'common.Credentials', {
                'LoginId': { n: 'loginId', t: 2 },
                'Password': { n: 'password', t: 2 },
                'IpAddress': { n: 'ipAddress', t: 2 },
                'RefererUrl': { n: 'refererUrl', t: 2 },
                'SecurityToken': { n: 'securityToken', r: 'common.SecurityToken', r2: function () { return common.SecurityToken; }, f: 1 }
            })
        ], Credentials);
        return Credentials;
    }(osa.base.Complex));
    common.Credentials = Credentials;
})(common || (common = {}));
(function (common) {
    var CustomKey = /** @class */ (function (_super) {
        __extends(CustomKey, _super);
        /**
        *
        * @param data - an initial data
        */
        function CustomKey(data) {
            return _super.call(this, data) || this;
        }
        CustomKey = __decorate([
            osa.decorators.ComplexType(common, 'common.CustomKey', {
                'Key': { n: 'key', t: 2 },
                'DisplayName': { n: 'displayName', t: 2 }
            })
        ], CustomKey);
        return CustomKey;
    }(osa.base.Complex));
    common.CustomKey = CustomKey;
})(common || (common = {}));
(function (common) {
    var DateTimePredicate = /** @class */ (function (_super) {
        __extends(DateTimePredicate, _super);
        /**
        *
        * @param data - an initial data
        */
        function DateTimePredicate(data) {
            return _super.call(this, data) || this;
        }
        DateTimePredicate = __decorate([
            osa.decorators.ComplexType(common, 'common.DateTimePredicate', {
                'DateTime1': { n: 'dateTime1', t: 15 },
                'DateTime2': { n: 'dateTime2', t: 15 },
                'DateOperator': { n: 'dateOperator', t: 4, r2: function () { return common.DateOperator; } }
            })
        ], DateTimePredicate);
        return DateTimePredicate;
    }(osa.base.Complex));
    common.DateTimePredicate = DateTimePredicate;
})(common || (common = {}));
(function (common) {
    var DateTimeRestriction = /** @class */ (function (_super) {
        __extends(DateTimeRestriction, _super);
        /**
        * @deprecated deprecated
        * @param data - an initial data
        */
        function DateTimeRestriction(data) {
            return _super.call(this, data) || this;
        }
        DateTimeRestriction = __decorate([
            osa.decorators.ComplexType(common, 'common.DateTimeRestriction', {
                'Date1': { n: 'date1', t: 3 },
                'Date2': { n: 'date2', t: 3 },
                'DateOperator': { n: 'dateOperator', t: 4, r2: function () { return common.DateOperator; } }
            })
        ], DateTimeRestriction);
        return DateTimeRestriction;
    }(osa.base.Complex));
    common.DateTimeRestriction = DateTimeRestriction;
})(common || (common = {}));
(function (common) {
    var Delay = /** @class */ (function (_super) {
        __extends(Delay, _super);
        /**
        *
        * @param data - an initial data
        */
        function Delay(data) {
            return _super.call(this, data) || this;
        }
        Delay = __decorate([
            osa.decorators.ComplexType(common, 'common.Delay', {
                'Length': { n: 'length', t: 9 },
                'Unit': { n: 'unit', t: 4, r2: function () { return common.TimeUnit; } }
            })
        ], Delay);
        return Delay;
    }(osa.base.Complex));
    common.Delay = Delay;
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var CustomPropertyType = /** @class */ (function (_super) {
            __extends(CustomPropertyType, _super);
            /**
            *
            * @param data - an initial data
            */
            function CustomPropertyType(data) {
                return _super.call(this, data) || this;
            }
            CustomPropertyType = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.CustomPropertyType', {
                    'Element': { n: 'element', r: 'common.ExtensionItem', r2: function () { return common.ExtensionItem; }, f: 5 }
                })
            ], CustomPropertyType);
            return CustomPropertyType;
        }(osa.base.Complex));
        capabilities.CustomPropertyType = CustomPropertyType;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var ExtendedMetadata = /** @class */ (function (_super) {
        __extends(ExtendedMetadata, _super);
        /**
        *
        * @param data - an initial data
        */
        function ExtendedMetadata(data) {
            return _super.call(this, data) || this;
        }
        ExtendedMetadata = __decorate([
            osa.decorators.ComplexType(common, 'common.ExtendedMetadata', {
                'Objects': { n: 'objects', r: 'common.ExtendedMetadataObject', r2: function () { return common.ExtendedMetadataObject; }, f: 5 },
                'Groups': { n: 'groups', r: 'common.ExtendedMetadataGroup', r2: function () { return common.ExtendedMetadataGroup; }, f: 5 }
            })
        ], ExtendedMetadata);
        return ExtendedMetadata;
    }(osa.base.Complex));
    common.ExtendedMetadata = ExtendedMetadata;
})(common || (common = {}));
(function (common) {
    var ExtendedMetadataGroup = /** @class */ (function (_super) {
        __extends(ExtendedMetadataGroup, _super);
        /**
        *
        * @param data - an initial data
        */
        function ExtendedMetadataGroup(data) {
            return _super.call(this, data) || this;
        }
        ExtendedMetadataGroup = __decorate([
            osa.decorators.ComplexType(common, 'common.ExtendedMetadataGroup', {
                'Name': { n: 'name', t: 2 },
                'Objects': { n: 'objects', r: 'common.ExtendedMetadataObject', r2: function () { return common.ExtendedMetadataObject; }, f: 5 },
                'Groups': { n: 'groups', r: 'common.ExtendedMetadataGroup', r2: function () { return common.ExtendedMetadataGroup; }, f: 5 },
                'Id': { n: 'id', t: 2 }
            })
        ], ExtendedMetadataGroup);
        return ExtendedMetadataGroup;
    }(osa.base.Complex));
    common.ExtendedMetadataGroup = ExtendedMetadataGroup;
})(common || (common = {}));
(function (common) {
    var ExtendedMetadataObject = /** @class */ (function (_super) {
        __extends(ExtendedMetadataObject, _super);
        /**
        *
        * @param data - an initial data
        */
        function ExtendedMetadataObject(data) {
            return _super.call(this, data) || this;
        }
        ExtendedMetadataObject = __decorate([
            osa.decorators.ComplexType(common, 'common.ExtendedMetadataObject', {
                'Name': { n: 'name', t: 2 },
                'Value': { n: 'value', t: 2 },
                'Attributes': { n: 'attributes', r: 'common.KeyValuePair', r2: function () { return common.KeyValuePair; }, f: 5 }
            })
        ], ExtendedMetadataObject);
        return ExtendedMetadataObject;
    }(osa.base.Complex));
    common.ExtendedMetadataObject = ExtendedMetadataObject;
})(common || (common = {}));
(function (common) {
    var ExtensionItem = /** @class */ (function (_super) {
        __extends(ExtensionItem, _super);
        /**
        *
        * @param data - an initial data
        */
        function ExtensionItem(data) {
            return _super.call(this, data) || this;
        }
        ExtensionItem = __decorate([
            osa.decorators.ComplexType(common, 'common.ExtensionItem', {
                'Key': { n: 'key', t: 2 },
                'Value': { n: 'value', t: 2 }
            })
        ], ExtensionItem);
        return ExtensionItem;
    }(osa.base.Complex));
    common.ExtensionItem = ExtensionItem;
})(common || (common = {}));
(function (common) {
    var HistoryOptions = /** @class */ (function (_super) {
        __extends(HistoryOptions, _super);
        /**
        *
        * @param data - an initial data
        */
        function HistoryOptions(data) {
            return _super.call(this, data) || this;
        }
        HistoryOptions = __decorate([
            osa.decorators.ComplexType(common, 'common.HistoryOptions', {
                'Action': { n: 'action', t: 2 },
                'Tag': { n: 'tag', t: 2 },
                'SaveToHistory': { n: 'saveToHistory', t: 1 }
            })
        ], HistoryOptions);
        return HistoryOptions;
    }(osa.base.Complex));
    common.HistoryOptions = HistoryOptions;
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var AbstractServiceCapability = /** @class */ (function (_super) {
            __extends(AbstractServiceCapability, _super);
            /**
            *
            * @param data - an initial data
            */
            function AbstractServiceCapability(data) {
                var _this = _super.call(this, data) || this;
                osa.base.checkInstanceCreate(_this, AbstractServiceCapability_1);
                return _this;
            }
            AbstractServiceCapability_1 = AbstractServiceCapability;
            var AbstractServiceCapability_1;
            AbstractServiceCapability = AbstractServiceCapability_1 = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.AbstractServiceCapability', {
                    'Implemented': { n: 'implemented', t: 1 },
                    'CustomProperty': { n: 'customProperty', r: 'common.capabilities.CustomPropertyType', r2: function () { return common.capabilities.CustomPropertyType; }, f: 1 },
                    'Restriction': { n: 'restriction', r: 'common.capabilities.Restriction', r2: function () { return common.capabilities.Restriction; }, f: 5 }
                })
            ], AbstractServiceCapability);
            return AbstractServiceCapability;
        }(osa.base.Complex));
        capabilities.AbstractServiceCapability = AbstractServiceCapability;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var AbstractOperationCapability = /** @class */ (function (_super) {
            __extends(AbstractOperationCapability, _super);
            /**
            *
            * @param data - an initial data
            */
            function AbstractOperationCapability(data) {
                var _this = _super.call(this, data) || this;
                osa.base.checkInstanceCreate(_this, AbstractOperationCapability_1);
                return _this;
            }
            AbstractOperationCapability_1 = AbstractOperationCapability;
            var AbstractOperationCapability_1;
            AbstractOperationCapability = AbstractOperationCapability_1 = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.AbstractOperationCapability', {
                    'CustomProperty': { n: 'customProperty', r: 'common.capabilities.CustomPropertyType', r2: function () { return common.capabilities.CustomPropertyType; }, f: 1 },
                    'Restriction': { n: 'restriction', r: 'common.capabilities.Restriction', r2: function () { return common.capabilities.Restriction; }, f: 5 },
                    'Implemented': { n: 'implemented', t: 1 }
                })
            ], AbstractOperationCapability);
            return AbstractOperationCapability;
        }(osa.base.Complex));
        capabilities.AbstractOperationCapability = AbstractOperationCapability;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var Interval = /** @class */ (function (_super) {
        __extends(Interval, _super);
        /**
        *
        * @param data - an initial data
        */
        function Interval(data) {
            return _super.call(this, data) || this;
        }
        Interval = __decorate([
            osa.decorators.ComplexType(common, 'common.Interval', {
                'StartedOn': { n: 'startedOn', t: 15 }
            })
        ], Interval);
        return Interval;
    }(osa.base.Complex));
    common.Interval = Interval;
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var AbstractDomainCapability = /** @class */ (function (_super) {
            __extends(AbstractDomainCapability, _super);
            /**
            *
            * @param data - an initial data
            */
            function AbstractDomainCapability(data) {
                var _this = _super.call(this, data) || this;
                osa.base.checkInstanceCreate(_this, AbstractDomainCapability_1);
                return _this;
            }
            AbstractDomainCapability_1 = AbstractDomainCapability;
            var AbstractDomainCapability_1;
            AbstractDomainCapability = AbstractDomainCapability_1 = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.AbstractDomainCapability', {
                    'CustomProperty': { n: 'customProperty', r: 'common.capabilities.CustomPropertyType', r2: function () { return common.capabilities.CustomPropertyType; }, f: 1 },
                    'Request': { n: 'request', r: 'common.capabilities.RequestCapabilities', r2: function () { return common.capabilities.RequestCapabilities; }, f: 1 },
                    'Restriction': { n: 'restriction', r: 'common.capabilities.Restriction', r2: function () { return common.capabilities.Restriction; }, f: 5 },
                    'Diagnostics': { n: 'diagnostics', r: 'common.capabilities.DiagnosticsServiceCapabilities', r2: function () { return common.capabilities.DiagnosticsServiceCapabilities; }, f: 1 }
                })
            ], AbstractDomainCapability);
            return AbstractDomainCapability;
        }(osa.base.Complex));
        capabilities.AbstractDomainCapability = AbstractDomainCapability;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var ValidationError = /** @class */ (function (_super) {
            __extends(ValidationError, _super);
            /**
            *
            * @param data - an initial data
            */
            function ValidationError(data) {
                return _super.call(this, data) || this;
            }
            ValidationError = __decorate([
                osa.decorators.ComplexType(common, 'common.message.ValidationError', {
                    'Message': { n: 'message', t: 2 },
                    'Path': { n: 'path', r: 'common.capabilities.RestrictionPath', r2: function () { return common.capabilities.RestrictionPath; }, f: 1 }
                })
            ], ValidationError);
            return ValidationError;
        }(osa.base.Complex));
        message.ValidationError = ValidationError;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var RestrictionPath = /** @class */ (function (_super) {
            __extends(RestrictionPath, _super);
            /**
            *
            * @param data - an initial data
            */
            function RestrictionPath(data) {
                return _super.call(this, data) || this;
            }
            RestrictionPath = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.RestrictionPath', {
                    'Item': { n: 'item', r: 'common.capabilities.RestrictionPathItem', r2: function () { return common.capabilities.RestrictionPathItem; }, f: 5 }
                })
            ], RestrictionPath);
            return RestrictionPath;
        }(osa.base.Complex));
        capabilities.RestrictionPath = RestrictionPath;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var ResponseInfo = /** @class */ (function (_super) {
            __extends(ResponseInfo, _super);
            /**
            *
            * @param data - an initial data
            */
            function ResponseInfo(data) {
                return _super.call(this, data) || this;
            }
            ResponseInfo = __decorate([
                osa.decorators.ComplexType(common, 'common.message.ResponseInfo', {
                    'InstanceId': { n: 'instanceId', r: 'common.message.InstanceId', r2: function () { return common.message.InstanceId; }, f: 1 },
                    'ExtensionItems': { n: 'extensionItems', r: 'common.ExtensionItem', r2: function () { return common.ExtensionItem; }, f: 5 },
                    'Cache': { n: 'cache', r: 'common.message.ResponseInfoCache', r2: function () { return common.message.ResponseInfoCache; }, f: 1 },
                    'CorrelationId': { n: 'correlationId', r: 'common.message.CorrelationId', r2: function () { return common.message.CorrelationId; }, f: 1 },
                    'ProductId': { n: 'productId', r: 'common.ProductId', r2: function () { return common.ProductId; }, f: 1 },
                    'NoCache': { n: 'noCache', t: 1 },
                    'Timestamp': { n: 'timestamp', t: 15 },
                    'ResourceId': { n: 'resourceId', t: 2 }
                })
            ], ResponseInfo);
            return ResponseInfo;
        }(osa.base.Complex));
        message.ResponseInfo = ResponseInfo;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var RequestInfo = /** @class */ (function (_super) {
            __extends(RequestInfo, _super);
            /**
            *
            * @param data - an initial data
            */
            function RequestInfo(data) {
                return _super.call(this, data) || this;
            }
            RequestInfo = __decorate([
                osa.decorators.ComplexType(common, 'common.message.RequestInfo', {
                    'ClientInfo': { n: 'clientInfo', r: 'common.message.OsaClientInfo', r2: function () { return common.message.OsaClientInfo; }, f: 1 },
                    'SecurityToken': { n: 'securityToken', r: 'common.SecurityToken', r2: function () { return common.SecurityToken; }, f: 1 },
                    'CorrelationId': { n: 'correlationId', r: 'common.message.CorrelationId', r2: function () { return common.message.CorrelationId; }, f: 1 },
                    'ExtensionItems': { n: 'extensionItems', r: 'common.ExtensionItem', r2: function () { return common.ExtensionItem; }, f: 5 },
                    'ProductId': { n: 'productId', r: 'common.ProductId', r2: function () { return common.ProductId; }, f: 1 },
                    'NoCache': { n: 'noCache', t: 1 },
                    'Timestamp': { n: 'timestamp', t: 15 },
                    'Tenant': { n: 'tenant', t: 2 },
                    'ResourceId': { n: 'resourceId', t: 2 },
                    'Apikey': { n: 'apikey', t: 2, f: 4 },
                    'Permissions': { n: 'permissions', r: 'common.Permissions', r2: function () { return common.Permissions; }, f: 1 }
                })
            ], RequestInfo);
            return RequestInfo;
        }(osa.base.Complex));
        message.RequestInfo = RequestInfo;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var KeyValuePair = /** @class */ (function (_super) {
        __extends(KeyValuePair, _super);
        /**
        *
        * @param data - an initial data
        */
        function KeyValuePair(data) {
            return _super.call(this, data) || this;
        }
        KeyValuePair = __decorate([
            osa.decorators.ComplexType(common, 'common.KeyValuePair', {
                'Key': { n: 'key', t: 2 },
                'Value': { n: 'value', t: 2 }
            })
        ], KeyValuePair);
        return KeyValuePair;
    }(osa.base.Complex));
    common.KeyValuePair = KeyValuePair;
})(common || (common = {}));
(function (common) {
    var KeyValuePairList = /** @class */ (function (_super) {
        __extends(KeyValuePairList, _super);
        /**
        *
        * @param data - an initial data
        */
        function KeyValuePairList(data) {
            return _super.call(this, data) || this;
        }
        KeyValuePairList = __decorate([
            osa.decorators.ComplexType(common, 'common.KeyValuePairList', {
                'Item': { n: 'item', r: 'common.KeyValuePair', r2: function () { return common.KeyValuePair; }, f: 5 }
            })
        ], KeyValuePairList);
        return KeyValuePairList;
    }(osa.base.Complex));
    common.KeyValuePairList = KeyValuePairList;
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var Error = /** @class */ (function (_super) {
            __extends(Error, _super);
            /**
            *
            * @param data - an initial data
            */
            function Error(data) {
                return _super.call(this, data) || this;
            }
            Error = __decorate([
                osa.decorators.ComplexType(common, 'common.message.Error', {
                    'ErrorId': { n: 'errorId', r: 'common.message.ErrorId', r2: function () { return common.message.ErrorId; }, f: 1 },
                    'InstanceId': { n: 'instanceId', r: 'common.message.InstanceId', r2: function () { return common.message.InstanceId; }, f: 1 },
                    'Message': { n: 'message', t: 2 },
                    'Exception': { n: 'exception', t: 2 }
                })
            ], Error);
            return Error;
        }(osa.base.Complex));
        message.Error = Error;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var PagingInfo = /** @class */ (function (_super) {
        __extends(PagingInfo, _super);
        /**
        *
        * @param data - an initial data
        */
        function PagingInfo(data) {
            return _super.call(this, data) || this;
        }
        PagingInfo = __decorate([
            osa.decorators.ComplexType(common, 'common.PagingInfo', {
                'StartItemIndex': { n: 'startItemIndex', t: 9 },
                'NumberOfItems': { n: 'numberOfItems', t: 9 }
            })
        ], PagingInfo);
        return PagingInfo;
    }(osa.base.Complex));
    common.PagingInfo = PagingInfo;
})(common || (common = {}));
(function (common) {
    var Permissions = /** @class */ (function (_super) {
        __extends(Permissions, _super);
        /**
        *
        * @param data - an initial data
        */
        function Permissions(data) {
            return _super.call(this, data) || this;
        }
        Permissions = __decorate([
            osa.decorators.ComplexType(common, 'common.Permissions', {
                'Content': { n: 'content', t: 2 }
            })
        ], Permissions);
        return Permissions;
    }(osa.base.Complex));
    common.Permissions = Permissions;
})(common || (common = {}));
(function (common) {
    var PersonName = /** @class */ (function (_super) {
        __extends(PersonName, _super);
        /**
        *
        * @param data - an initial data
        */
        function PersonName(data) {
            return _super.call(this, data) || this;
        }
        PersonName = __decorate([
            osa.decorators.ComplexType(common, 'common.PersonName', {
                'FirstName': { n: 'firstName', t: 2 },
                'LastName': { n: 'lastName', t: 2 }
            })
        ], PersonName);
        return PersonName;
    }(osa.base.Complex));
    common.PersonName = PersonName;
})(common || (common = {}));
(function (common) {
    var PitSearchOptions = /** @class */ (function (_super) {
        __extends(PitSearchOptions, _super);
        /**
        *
        * @param data - an initial data
        */
        function PitSearchOptions(data) {
            return _super.call(this, data) || this;
        }
        PitSearchOptions = __decorate([
            osa.decorators.ComplexType(common, 'common.PitSearchOptions', {
                'ResearchDate': { n: 'researchDate', r: 'common.DateTimeRestriction', r2: function () { return common.DateTimeRestriction; }, f: 1 },
                'FilterFieldId': { n: 'filterFieldId', t: 2 },
                'DocumentPitStates': { n: 'documentPitStates', t: 2 },
                'DocumentFamilyPitStates': { n: 'documentFamilyPitStates', t: 2, f: 4 },
                'PitSearchRule': { n: 'pitSearchRule', t: 4, r2: function () { return common.PitContextSearchRule; } }
            })
        ], PitSearchOptions);
        return PitSearchOptions;
    }(osa.base.Complex));
    common.PitSearchOptions = PitSearchOptions;
})(common || (common = {}));
(function (common) {
    var ProductInfo = /** @class */ (function (_super) {
        __extends(ProductInfo, _super);
        /**
        *
        * @param data - an initial data
        */
        function ProductInfo(data) {
            return _super.call(this, data) || this;
        }
        ProductInfo = __decorate([
            osa.decorators.ComplexType(common, 'common.ProductInfo', {
                'ProductId': { n: 'productId', r: 'common.ProductId', r2: function () { return common.ProductId; }, f: 1 },
                'Name': { n: 'name', t: 2 }
            })
        ], ProductInfo);
        return ProductInfo;
    }(osa.base.Complex));
    common.ProductInfo = ProductInfo;
})(common || (common = {}));
(function (common) {
    var ScheduleTimeInstance = /** @class */ (function (_super) {
        __extends(ScheduleTimeInstance, _super);
        /**
        *
        * @param data - an initial data
        */
        function ScheduleTimeInstance(data) {
            return _super.call(this, data) || this;
        }
        ScheduleTimeInstance = __decorate([
            osa.decorators.ComplexType(common, 'common.ScheduleTimeInstance', {
                'Frequency': { n: 'frequency', t: 4, r2: function () { return common.EventFrequency; } },
                'DayOfWeek': { n: 'dayOfWeek', t: 4, r2: function () { return common.DayOfWeek; } },
                'DayOfMonth': { n: 'dayOfMonth', t: 9 },
                'TimeOfDay': { n: 'timeOfDay', t: 13 },
                'Delay': { n: 'delay', r: 'common.Delay', r2: function () { return common.Delay; }, f: 1 }
            })
        ], ScheduleTimeInstance);
        return ScheduleTimeInstance;
    }(osa.base.Complex));
    common.ScheduleTimeInstance = ScheduleTimeInstance;
})(common || (common = {}));
(function (common) {
    var SecurityAttribute = /** @class */ (function (_super) {
        __extends(SecurityAttribute, _super);
        /**
        *
        * @param data - an initial data
        */
        function SecurityAttribute(data) {
            return _super.call(this, data) || this;
        }
        SecurityAttribute = __decorate([
            osa.decorators.ComplexType(common, 'common.SecurityAttribute', {
                'SecurityDomainId': { n: 'securityDomainId', r: 'common.SecurityDomainId', r2: function () { return common.SecurityDomainId; }, f: 1 },
                'Property': { n: 'property', r: 'common.KeyValuePair', r2: function () { return common.KeyValuePair; }, f: 5 }
            })
        ], SecurityAttribute);
        return SecurityAttribute;
    }(osa.base.Complex));
    common.SecurityAttribute = SecurityAttribute;
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var ClientInfo = /** @class */ (function (_super) {
            __extends(ClientInfo, _super);
            /**
            *
            * @param data - an initial data
            */
            function ClientInfo(data) {
                return _super.call(this, data) || this;
            }
            ClientInfo = __decorate([
                osa.decorators.ComplexType(common, 'common.message.ClientInfo', {
                    'ClientId': { n: 'clientId', r: 'common.message.ClientId', r2: function () { return common.message.ClientId; }, f: 1 },
                    'Version': { n: 'version', t: 2 },
                    'InstanceId': { n: 'instanceId', r: 'common.message.InstanceId', r2: function () { return common.message.InstanceId; }, f: 1 },
                    'InstanceTag': { n: 'instanceTag', t: 2 },
                    'Locale': { n: 'locale', t: 2 },
                    'Timezone': { n: 'timezone', t: 2 },
                    'MachineName': { n: 'machineName', t: 2 },
                    'OperatingSystemName': { n: 'operatingSystemName', t: 2 },
                    'OperatingSystemVersion': { n: 'operatingSystemVersion', t: 2 },
                    'DeviceModel': { n: 'deviceModel', t: 2 },
                    'DeviceModelVersion': { n: 'deviceModelVersion', t: 2 },
                    'RuntimeName': { n: 'runtimeName', t: 2 },
                    'RuntimeVersion': { n: 'runtimeVersion', t: 2 },
                    'Origin': { n: 'origin', r: 'common.message.ClientInfo', r2: function () { return common.message.ClientInfo; }, f: 1 },
                    'OriginIp': { n: 'originIp', t: 2 },
                    'ExtensionItems': { n: 'extensionItems', r: 'common.ExtensionItem', r2: function () { return common.ExtensionItem; }, f: 5 }
                })
            ], ClientInfo);
            return ClientInfo;
        }(osa.base.Complex));
        message.ClientInfo = ClientInfo;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var SecurityToken = /** @class */ (function (_super) {
        __extends(SecurityToken, _super);
        /**
        *
        * @param data - an initial data
        */
        function SecurityToken(data) {
            return _super.call(this, data) || this;
        }
        SecurityToken = __decorate([
            osa.decorators.ComplexType(common, 'common.SecurityToken', {
                'Content': { n: 'content', t: 2 }
            })
        ], SecurityToken);
        return SecurityToken;
    }(osa.base.Complex));
    common.SecurityToken = SecurityToken;
})(common || (common = {}));
(function (common) {
    var SessionTicket = /** @class */ (function (_super) {
        __extends(SessionTicket, _super);
        /**
        *
        * @param data - an initial data
        */
        function SessionTicket(data) {
            return _super.call(this, data) || this;
        }
        SessionTicket = __decorate([
            osa.decorators.ComplexType(common, 'common.SessionTicket', {
                'Ticket': { n: 'ticket', t: 2 }
            })
        ], SessionTicket);
        return SessionTicket;
    }(osa.base.Complex));
    common.SessionTicket = SessionTicket;
})(common || (common = {}));
(function (common) {
    var TagInfo = /** @class */ (function (_super) {
        __extends(TagInfo, _super);
        /**
        *
        * @param data - an initial data
        */
        function TagInfo(data) {
            return _super.call(this, data) || this;
        }
        TagInfo = __decorate([
            osa.decorators.ComplexType(common, 'common.TagInfo', {
                'Tag': { n: 'tag', t: 2 },
                'Action': { n: 'action', t: 2 }
            })
        ], TagInfo);
        return TagInfo;
    }(osa.base.Complex));
    common.TagInfo = TagInfo;
})(common || (common = {}));
(function (common) {
    var TokenValue = /** @class */ (function (_super) {
        __extends(TokenValue, _super);
        /**
        *
        * @param data - an initial data
        */
        function TokenValue(data) {
            return _super.call(this, data) || this;
        }
        TokenValue = __decorate([
            osa.decorators.ComplexType(common, 'common.TokenValue', {
                'Name': { n: 'name', t: 2 },
                'Value': { n: 'value', t: 2 }
            })
        ], TokenValue);
        return TokenValue;
    }(osa.base.Complex));
    common.TokenValue = TokenValue;
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var CacheContainerVersionList = /** @class */ (function (_super) {
            __extends(CacheContainerVersionList, _super);
            /**
            *
            * @param data - an initial data
            */
            function CacheContainerVersionList(data) {
                return _super.call(this, data) || this;
            }
            CacheContainerVersionList = __decorate([
                osa.decorators.ComplexType(common, 'common.message.CacheContainerVersionList', {
                    'Item': { n: 'item', r: 'common.message.CacheContainerVersion', r2: function () { return common.message.CacheContainerVersion; }, f: 5 }
                })
            ], CacheContainerVersionList);
            return CacheContainerVersionList;
        }(osa.base.Complex));
        message.CacheContainerVersionList = CacheContainerVersionList;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var CacheContainerVersion = /** @class */ (function (_super) {
            __extends(CacheContainerVersion, _super);
            /**
            *
            * @param data - an initial data
            */
            function CacheContainerVersion(data) {
                return _super.call(this, data) || this;
            }
            CacheContainerVersion = __decorate([
                osa.decorators.ComplexType(common, 'common.message.CacheContainerVersion', {
                    'CacheContainerId': { n: 'cacheContainerId', r: 'common.message.CacheContainerId', r2: function () { return common.message.CacheContainerId; }, f: 1 },
                    'Version': { n: 'version', t: 2 }
                })
            ], CacheContainerVersion);
            return CacheContainerVersion;
        }(osa.base.Complex));
        message.CacheContainerVersion = CacheContainerVersion;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var User = /** @class */ (function (_super) {
        __extends(User, _super);
        /**
        *
        * @param data - an initial data
        */
        function User(data) {
            return _super.call(this, data) || this;
        }
        User = __decorate([
            osa.decorators.ComplexType(common, 'common.User', {
                'LoginId': { n: 'loginId', r: 'common.LoginId', r2: function () { return common.LoginId; }, f: 1 },
                'UserKey': { n: 'userKey', r: 'common.UserKey', r2: function () { return common.UserKey; }, f: 1 },
                'Domain': { n: 'domain', r: 'common.Domain', r2: function () { return common.Domain; }, f: 1 },
                'UserCategory': { n: 'userCategory', t: 2 },
                'Name': { n: 'name', t: 2 },
                'Account': { n: 'account', t: 2 }
            })
        ], User);
        return User;
    }(osa.base.Complex));
    common.User = User;
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var CacheContainerIdList = /** @class */ (function (_super) {
            __extends(CacheContainerIdList, _super);
            /**
            *
            * @param data - an initial data
            */
            function CacheContainerIdList(data) {
                return _super.call(this, data) || this;
            }
            CacheContainerIdList = __decorate([
                osa.decorators.ComplexType(common, 'common.message.CacheContainerIdList', {
                    'Item': { n: 'item', r: 'common.message.CacheContainerId', r2: function () { return common.message.CacheContainerId; }, f: 5 }
                })
            ], CacheContainerIdList);
            return CacheContainerIdList;
        }(osa.base.Complex));
        message.CacheContainerIdList = CacheContainerIdList;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var VersionRestriction = /** @class */ (function (_super) {
        __extends(VersionRestriction, _super);
        /**
        *
        * @param data - an initial data
        */
        function VersionRestriction(data) {
            return _super.call(this, data) || this;
        }
        VersionRestriction = __decorate([
            osa.decorators.ComplexType(common, 'common.VersionRestriction', {
                'Version1': { n: 'version1', t: 2 },
                'Version2': { n: 'version2', t: 2 },
                'VersionOperator': { n: 'versionOperator', t: 4, r2: function () { return common.VersionOperator; } }
            })
        ], VersionRestriction);
        return VersionRestriction;
    }(osa.base.Complex));
    common.VersionRestriction = VersionRestriction;
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var AbstractMessage = /** @class */ (function (_super) {
            __extends(AbstractMessage, _super);
            /**
            *
            * @param data - an initial data
            */
            function AbstractMessage(data) {
                var _this = _super.call(this, data) || this;
                osa.base.checkInstanceCreate(_this, AbstractMessage_1);
                return _this;
            }
            AbstractMessage_1 = AbstractMessage;
            var AbstractMessage_1;
            AbstractMessage = AbstractMessage_1 = __decorate([
                osa.decorators.ComplexType(common, 'common.message.AbstractMessage', {})
            ], AbstractMessage);
            return AbstractMessage;
        }(osa.base.Complex));
        message.AbstractMessage = AbstractMessage;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var LoginId = /** @class */ (function (_super) {
        __extends(LoginId, _super);
        /**
        *
        * @param data - an initial data
        */
        function LoginId(data) {
            return _super.call(this, data) || this;
        }
        LoginId = __decorate([
            osa.decorators.ComplexType(common, 'common.LoginId', {})
        ], LoginId);
        return LoginId;
    }(common.AbstractId));
    common.LoginId = LoginId;
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var ErrorId = /** @class */ (function (_super) {
            __extends(ErrorId, _super);
            /**
            *
            * @param data - an initial data
            */
            function ErrorId(data) {
                return _super.call(this, data) || this;
            }
            ErrorId = __decorate([
                osa.decorators.ComplexType(common, 'common.message.ErrorId', {})
            ], ErrorId);
            return ErrorId;
        }(common.AbstractId));
        message.ErrorId = ErrorId;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var ClientId = /** @class */ (function (_super) {
            __extends(ClientId, _super);
            /**
            *
            * @param data - an initial data
            */
            function ClientId(data) {
                return _super.call(this, data) || this;
            }
            ClientId = __decorate([
                osa.decorators.ComplexType(common, 'common.message.ClientId', {})
            ], ClientId);
            return ClientId;
        }(common.AbstractId));
        message.ClientId = ClientId;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var DelegatedUser = /** @class */ (function (_super) {
        __extends(DelegatedUser, _super);
        /**
        *
        * @param data - an initial data
        */
        function DelegatedUser(data) {
            return _super.call(this, data) || this;
        }
        DelegatedUser = __decorate([
            osa.decorators.ComplexType(common, 'common.DelegatedUser', {
                'DelegateUserKey': { n: 'delegateUserKey', r: 'common.UserKey', r2: function () { return common.UserKey; }, f: 1 },
                'DelegateDomain': { n: 'delegateDomain', r: 'common.SecurityDomainId', r2: function () { return common.SecurityDomainId; }, f: 1 },
                'SubDelegate': { n: 'subDelegate', r: 'common.DelegatedUser', r2: function () { return common.DelegatedUser; }, f: 1 }
            })
        ], DelegatedUser);
        return DelegatedUser;
    }(common.User));
    common.DelegatedUser = DelegatedUser;
})(common || (common = {}));
(function (common) {
    var SubjectId = /** @class */ (function (_super) {
        __extends(SubjectId, _super);
        /**
        *
        * @param data - an initial data
        */
        function SubjectId(data) {
            return _super.call(this, data) || this;
        }
        SubjectId = __decorate([
            osa.decorators.ComplexType(common, 'common.SubjectId', {})
        ], SubjectId);
        return SubjectId;
    }(common.AbstractId));
    common.SubjectId = SubjectId;
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var CorrelationId = /** @class */ (function (_super) {
            __extends(CorrelationId, _super);
            /**
            *
            * @param data - an initial data
            */
            function CorrelationId(data) {
                return _super.call(this, data) || this;
            }
            CorrelationId = __decorate([
                osa.decorators.ComplexType(common, 'common.message.CorrelationId', {})
            ], CorrelationId);
            return CorrelationId;
        }(common.AbstractId));
        message.CorrelationId = CorrelationId;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var Domain = /** @class */ (function (_super) {
        __extends(Domain, _super);
        /**
        * @deprecated deprecated
        * @param data - an initial data
        */
        function Domain(data) {
            return _super.call(this, data) || this;
        }
        Domain = __decorate([
            osa.decorators.ComplexType(common, 'common.Domain', {})
        ], Domain);
        return Domain;
    }(common.AbstractId));
    common.Domain = Domain;
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var PathRestriction = /** @class */ (function (_super) {
            __extends(PathRestriction, _super);
            /**
            *
            * @param data - an initial data
            */
            function PathRestriction(data) {
                var _this = _super.call(this, data) || this;
                osa.base.checkInstanceCreate(_this, PathRestriction_1);
                return _this;
            }
            PathRestriction_1 = PathRestriction;
            var PathRestriction_1;
            PathRestriction = PathRestriction_1 = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.PathRestriction', {
                    'Path': { n: 'path', r: 'common.capabilities.RestrictionPath', r2: function () { return common.capabilities.RestrictionPath; }, f: 1 }
                })
            ], PathRestriction);
            return PathRestriction;
        }(common.capabilities.Restriction));
        capabilities.PathRestriction = PathRestriction;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var CommonId = /** @class */ (function (_super) {
        __extends(CommonId, _super);
        /**
        *
        * @param data - an initial data
        */
        function CommonId(data) {
            return _super.call(this, data) || this;
        }
        CommonId = __decorate([
            osa.decorators.ComplexType(common, 'common.CommonId', {})
        ], CommonId);
        return CommonId;
    }(common.AbstractId));
    common.CommonId = CommonId;
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var OsaClientInfo = /** @class */ (function (_super) {
            __extends(OsaClientInfo, _super);
            /**
            *
            * @param data - an initial data
            */
            function OsaClientInfo(data) {
                return _super.call(this, data) || this;
            }
            OsaClientInfo = __decorate([
                osa.decorators.ComplexType(common, 'common.message.OsaClientInfo', {
                    'DomainVersion': { n: 'domainVersion', t: 2 },
                    'FrameworkVersion': { n: 'frameworkVersion', t: 2 }
                })
            ], OsaClientInfo);
            return OsaClientInfo;
        }(common.message.ClientInfo));
        message.OsaClientInfo = OsaClientInfo;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var UserKey = /** @class */ (function (_super) {
        __extends(UserKey, _super);
        /**
        *
        * @param data - an initial data
        */
        function UserKey(data) {
            return _super.call(this, data) || this;
        }
        UserKey = __decorate([
            osa.decorators.ComplexType(common, 'common.UserKey', {})
        ], UserKey);
        return UserKey;
    }(common.AbstractId));
    common.UserKey = UserKey;
})(common || (common = {}));
(function (common) {
    var ProductId = /** @class */ (function (_super) {
        __extends(ProductId, _super);
        /**
        *
        * @param data - an initial data
        */
        function ProductId(data) {
            return _super.call(this, data) || this;
        }
        ProductId = __decorate([
            osa.decorators.ComplexType(common, 'common.ProductId', {})
        ], ProductId);
        return ProductId;
    }(common.AbstractId));
    common.ProductId = ProductId;
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var InstanceId = /** @class */ (function (_super) {
            __extends(InstanceId, _super);
            /**
            *
            * @param data - an initial data
            */
            function InstanceId(data) {
                return _super.call(this, data) || this;
            }
            InstanceId = __decorate([
                osa.decorators.ComplexType(common, 'common.message.InstanceId', {})
            ], InstanceId);
            return InstanceId;
        }(common.AbstractId));
        message.InstanceId = InstanceId;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var SecurityDomainId = /** @class */ (function (_super) {
        __extends(SecurityDomainId, _super);
        /**
        *
        * @param data - an initial data
        */
        function SecurityDomainId(data) {
            return _super.call(this, data) || this;
        }
        SecurityDomainId = __decorate([
            osa.decorators.ComplexType(common, 'common.SecurityDomainId', {})
        ], SecurityDomainId);
        return SecurityDomainId;
    }(common.AbstractId));
    common.SecurityDomainId = SecurityDomainId;
})(common || (common = {}));
(function (common) {
    var ChannelId = /** @class */ (function (_super) {
        __extends(ChannelId, _super);
        /**
        *
        * @param data - an initial data
        */
        function ChannelId(data) {
            return _super.call(this, data) || this;
        }
        ChannelId = __decorate([
            osa.decorators.ComplexType(common, 'common.ChannelId', {})
        ], ChannelId);
        return ChannelId;
    }(common.AbstractId));
    common.ChannelId = ChannelId;
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var AbstractRequest = /** @class */ (function (_super) {
            __extends(AbstractRequest, _super);
            /**
            *
            * @param data - an initial data
            */
            function AbstractRequest(data) {
                var _this = _super.call(this, data) || this;
                osa.base.checkInstanceCreate(_this, AbstractRequest_1);
                return _this;
            }
            AbstractRequest_1 = AbstractRequest;
            var AbstractRequest_1;
            AbstractRequest = AbstractRequest_1 = __decorate([
                osa.decorators.ComplexType(common, 'common.message.AbstractRequest', {
                    'RequestInfo': { n: 'requestInfo', r: 'common.message.RequestInfo', r2: function () { return common.message.RequestInfo; }, f: 1 }
                })
            ], AbstractRequest);
            return AbstractRequest;
        }(common.message.AbstractMessage));
        message.AbstractRequest = AbstractRequest;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var CacheContainerId = /** @class */ (function (_super) {
            __extends(CacheContainerId, _super);
            /**
            *
            * @param data - an initial data
            */
            function CacheContainerId(data) {
                return _super.call(this, data) || this;
            }
            CacheContainerId = __decorate([
                osa.decorators.ComplexType(common, 'common.message.CacheContainerId', {})
            ], CacheContainerId);
            return CacheContainerId;
        }(common.AbstractId));
        message.CacheContainerId = CacheContainerId;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var AbstractReturn = /** @class */ (function (_super) {
            __extends(AbstractReturn, _super);
            /**
            *
            * @param data - an initial data
            */
            function AbstractReturn(data) {
                var _this = _super.call(this, data) || this;
                osa.base.checkInstanceCreate(_this, AbstractReturn_1);
                return _this;
            }
            AbstractReturn_1 = AbstractReturn;
            var AbstractReturn_1;
            AbstractReturn = AbstractReturn_1 = __decorate([
                osa.decorators.ComplexType(common, 'common.message.AbstractReturn', {})
            ], AbstractReturn);
            return AbstractReturn;
        }(common.message.AbstractMessage));
        message.AbstractReturn = AbstractReturn;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var OccurrenceRestriction = /** @class */ (function (_super) {
            __extends(OccurrenceRestriction, _super);
            /**
            *
            * @param data - an initial data
            */
            function OccurrenceRestriction(data) {
                return _super.call(this, data) || this;
            }
            OccurrenceRestriction = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.OccurrenceRestriction', {
                    'MinOccurrence': { n: 'minOccurrence', t: 9 },
                    'MaxOccurrence': { n: 'maxOccurrence', t: 9 }
                })
            ], OccurrenceRestriction);
            return OccurrenceRestriction;
        }(common.capabilities.PathRestriction));
        capabilities.OccurrenceRestriction = OccurrenceRestriction;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var message;
    (function (message) {
        var AbstractResponse = /** @class */ (function (_super) {
            __extends(AbstractResponse, _super);
            /**
            *
            * @param data - an initial data
            */
            function AbstractResponse(data) {
                var _this = _super.call(this, data) || this;
                osa.base.checkInstanceCreate(_this, AbstractResponse_1);
                return _this;
            }
            AbstractResponse_1 = AbstractResponse;
            var AbstractResponse_1;
            AbstractResponse = AbstractResponse_1 = __decorate([
                osa.decorators.ComplexType(common, 'common.message.AbstractResponse', {
                    'ResponseInfo': { n: 'responseInfo', r: 'common.message.ResponseInfo', r2: function () { return common.message.ResponseInfo; }, f: 1 }
                })
            ], AbstractResponse);
            return AbstractResponse;
        }(common.message.AbstractReturn));
        message.AbstractResponse = AbstractResponse;
    })(message = common.message || (common.message = {}));
})(common || (common = {}));
(function (common) {
    var AbstractFault = /** @class */ (function (_super) {
        __extends(AbstractFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function AbstractFault(data) {
            var _this = _super.call(this, data) || this;
            osa.base.checkInstanceCreate(_this, AbstractFault_1);
            return _this;
        }
        AbstractFault_1 = AbstractFault;
        var AbstractFault_1;
        AbstractFault = AbstractFault_1 = __decorate([
            osa.decorators.ComplexType(common, 'common.AbstractFault', {
                'Message': { n: 'message', t: 2 },
                'InstanceId': { n: 'instanceId', t: 2 },
                'CorrelationId': { n: 'correlationId', r: 'common.message.CorrelationId', r2: function () { return common.message.CorrelationId; }, f: 1 },
                'StackTrace': { n: 'stackTrace', t: 2 },
                'CustomData': { n: 'customData', r: 'common.ExtensionItem', r2: function () { return common.ExtensionItem; }, f: 5 },
                'Exception': { n: 'exception', t: 2 }
            })
        ], AbstractFault);
        return AbstractFault;
    }(common.message.AbstractReturn));
    common.AbstractFault = AbstractFault;
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var PatternRestriction = /** @class */ (function (_super) {
            __extends(PatternRestriction, _super);
            /**
            *
            * @param data - an initial data
            */
            function PatternRestriction(data) {
                return _super.call(this, data) || this;
            }
            PatternRestriction = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.PatternRestriction', {
                    'Match': { n: 'match', t: 2 }
                })
            ], PatternRestriction);
            return PatternRestriction;
        }(common.capabilities.PathRestriction));
        capabilities.PatternRestriction = PatternRestriction;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var InRangeRestriction = /** @class */ (function (_super) {
            __extends(InRangeRestriction, _super);
            /**
            *
            * @param data - an initial data
            */
            function InRangeRestriction(data) {
                return _super.call(this, data) || this;
            }
            InRangeRestriction = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.InRangeRestriction', {
                    'From': { n: 'from', t: 14 },
                    'To': { n: 'to', t: 14 },
                    'FromInclusive': { n: 'fromInclusive', t: 1 },
                    'ToInclusive': { n: 'toInclusive', t: 1 }
                })
            ], InRangeRestriction);
            return InRangeRestriction;
        }(common.capabilities.PathRestriction));
        capabilities.InRangeRestriction = InRangeRestriction;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var LengthRestriction = /** @class */ (function (_super) {
            __extends(LengthRestriction, _super);
            /**
            *
            * @param data - an initial data
            */
            function LengthRestriction(data) {
                return _super.call(this, data) || this;
            }
            LengthRestriction = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.LengthRestriction', {
                    'MinLength': { n: 'minLength', t: 9 },
                    'MaxLength': { n: 'maxLength', t: 9 }
                })
            ], LengthRestriction);
            return LengthRestriction;
        }(common.capabilities.PathRestriction));
        capabilities.LengthRestriction = LengthRestriction;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var NotInRangeRestriction = /** @class */ (function (_super) {
            __extends(NotInRangeRestriction, _super);
            /**
            *
            * @param data - an initial data
            */
            function NotInRangeRestriction(data) {
                return _super.call(this, data) || this;
            }
            NotInRangeRestriction = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.NotInRangeRestriction', {
                    'From': { n: 'from', t: 14 },
                    'To': { n: 'to', t: 14 },
                    'FromInclusive': { n: 'fromInclusive', t: 1 },
                    'ToInclusive': { n: 'toInclusive', t: 1 }
                })
            ], NotInRangeRestriction);
            return NotInRangeRestriction;
        }(common.capabilities.PathRestriction));
        capabilities.NotInRangeRestriction = NotInRangeRestriction;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var NotInListRestriction = /** @class */ (function (_super) {
            __extends(NotInListRestriction, _super);
            /**
            *
            * @param data - an initial data
            */
            function NotInListRestriction(data) {
                return _super.call(this, data) || this;
            }
            NotInListRestriction = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.NotInListRestriction', {
                    'Value': { n: 'value', t: 2, f: 4 }
                })
            ], NotInListRestriction);
            return NotInListRestriction;
        }(common.capabilities.PathRestriction));
        capabilities.NotInListRestriction = NotInListRestriction;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var capabilities;
    (function (capabilities) {
        var InListRestriction = /** @class */ (function (_super) {
            __extends(InListRestriction, _super);
            /**
            *
            * @param data - an initial data
            */
            function InListRestriction(data) {
                return _super.call(this, data) || this;
            }
            InListRestriction = __decorate([
                osa.decorators.ComplexType(common, 'common.capabilities.InListRestriction', {
                    'Value': { n: 'value', t: 2, f: 4 }
                })
            ], InListRestriction);
            return InListRestriction;
        }(common.capabilities.PathRestriction));
        capabilities.InListRestriction = InListRestriction;
    })(capabilities = common.capabilities || (common.capabilities = {}));
})(common || (common = {}));
(function (common) {
    var AbstractClientFault = /** @class */ (function (_super) {
        __extends(AbstractClientFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function AbstractClientFault(data) {
            var _this = _super.call(this, data) || this;
            osa.base.checkInstanceCreate(_this, AbstractClientFault_1);
            return _this;
        }
        AbstractClientFault_1 = AbstractClientFault;
        var AbstractClientFault_1;
        AbstractClientFault = AbstractClientFault_1 = __decorate([
            osa.decorators.ComplexType(common, 'common.AbstractClientFault', {})
        ], AbstractClientFault);
        return AbstractClientFault;
    }(common.AbstractFault));
    common.AbstractClientFault = AbstractClientFault;
})(common || (common = {}));
(function (common) {
    var unchecked;
    (function (unchecked) {
        var UnexpectedServerFault = /** @class */ (function (_super) {
            __extends(UnexpectedServerFault, _super);
            /**
            *
            * @param data - an initial data
            */
            function UnexpectedServerFault(data) {
                return _super.call(this, data) || this;
            }
            UnexpectedServerFault = __decorate([
                osa.decorators.ComplexType(common, 'common.unchecked.UnexpectedServerFault', {})
            ], UnexpectedServerFault);
            return UnexpectedServerFault;
        }(common.AbstractFault));
        unchecked.UnexpectedServerFault = UnexpectedServerFault;
    })(unchecked = common.unchecked || (common.unchecked = {}));
})(common || (common = {}));
(function (common) {
    var unchecked;
    (function (unchecked) {
        var RequestTooLargeFault = /** @class */ (function (_super) {
            __extends(RequestTooLargeFault, _super);
            /**
            *
            * @param data - an initial data
            */
            function RequestTooLargeFault(data) {
                return _super.call(this, data) || this;
            }
            RequestTooLargeFault = __decorate([
                osa.decorators.ComplexType(common, 'common.unchecked.RequestTooLargeFault', {
                    'Limit': { n: 'limit', t: 9 }
                })
            ], RequestTooLargeFault);
            return RequestTooLargeFault;
        }(common.unchecked.UnexpectedServerFault));
        unchecked.RequestTooLargeFault = RequestTooLargeFault;
    })(unchecked = common.unchecked || (common.unchecked = {}));
})(common || (common = {}));
(function (common) {
    var CommonClientFault = /** @class */ (function (_super) {
        __extends(CommonClientFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function CommonClientFault(data) {
            return _super.call(this, data) || this;
        }
        CommonClientFault = __decorate([
            osa.decorators.ComplexType(common, 'common.CommonClientFault', {})
        ], CommonClientFault);
        return CommonClientFault;
    }(common.AbstractClientFault));
    common.CommonClientFault = CommonClientFault;
})(common || (common = {}));
(function (common) {
    var NotAuthorizedFault = /** @class */ (function (_super) {
        __extends(NotAuthorizedFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function NotAuthorizedFault(data) {
            return _super.call(this, data) || this;
        }
        NotAuthorizedFault = __decorate([
            osa.decorators.ComplexType(common, 'common.NotAuthorizedFault', {
                'UnauthorizedResourceId': { n: 'unauthorizedResourceId', r: 'common.CommonId', r2: function () { return common.CommonId; }, f: 5 }
            })
        ], NotAuthorizedFault);
        return NotAuthorizedFault;
    }(common.AbstractClientFault));
    common.NotAuthorizedFault = NotAuthorizedFault;
})(common || (common = {}));
(function (common) {
    var InvalidTypeFault = /** @class */ (function (_super) {
        __extends(InvalidTypeFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidTypeFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidTypeFault = __decorate([
            osa.decorators.ComplexType(common, 'common.InvalidTypeFault', {
                'InvalidType': { n: 'invalidType', t: 2 }
            })
        ], InvalidTypeFault);
        return InvalidTypeFault;
    }(common.CommonClientFault));
    common.InvalidTypeFault = InvalidTypeFault;
})(common || (common = {}));
(function (common) {
    var InvalidIdFault = /** @class */ (function (_super) {
        __extends(InvalidIdFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidIdFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidIdFault = __decorate([
            osa.decorators.ComplexType(common, 'common.InvalidIdFault', {
                'Ids': { n: 'ids', r: 'common.CommonId', r2: function () { return common.CommonId; }, f: 5 }
            })
        ], InvalidIdFault);
        return InvalidIdFault;
    }(common.CommonClientFault));
    common.InvalidIdFault = InvalidIdFault;
})(common || (common = {}));
(function (common) {
    var ValidationFault = /** @class */ (function (_super) {
        __extends(ValidationFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function ValidationFault(data) {
            return _super.call(this, data) || this;
        }
        ValidationFault = __decorate([
            osa.decorators.ComplexType(common, 'common.ValidationFault', {
                'Error': { n: 'error', r: 'common.message.ValidationError', r2: function () { return common.message.ValidationError; }, f: 5 }
            })
        ], ValidationFault);
        return ValidationFault;
    }(common.CommonClientFault));
    common.ValidationFault = ValidationFault;
})(common || (common = {}));
(function (common) {
    var IdNotFoundFault = /** @class */ (function (_super) {
        __extends(IdNotFoundFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function IdNotFoundFault(data) {
            return _super.call(this, data) || this;
        }
        IdNotFoundFault = __decorate([
            osa.decorators.ComplexType(common, 'common.IdNotFoundFault', {
                'Id': { n: 'id', r: 'common.CommonId', r2: function () { return common.CommonId; }, f: 5 }
            })
        ], IdNotFoundFault);
        return IdNotFoundFault;
    }(common.CommonClientFault));
    common.IdNotFoundFault = IdNotFoundFault;
})(common || (common = {}));
(function (common) {
    var DuplicateIdFault = /** @class */ (function (_super) {
        __extends(DuplicateIdFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function DuplicateIdFault(data) {
            return _super.call(this, data) || this;
        }
        DuplicateIdFault = __decorate([
            osa.decorators.ComplexType(common, 'common.DuplicateIdFault', {
                'Id': { n: 'id', r: 'common.CommonId', r2: function () { return common.CommonId; }, f: 1 }
            })
        ], DuplicateIdFault);
        return DuplicateIdFault;
    }(common.CommonClientFault));
    common.DuplicateIdFault = DuplicateIdFault;
})(common || (common = {}));
(function (common) {
    var ConcurrentUsageExceededFault = /** @class */ (function (_super) {
        __extends(ConcurrentUsageExceededFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function ConcurrentUsageExceededFault(data) {
            return _super.call(this, data) || this;
        }
        ConcurrentUsageExceededFault = __decorate([
            osa.decorators.ComplexType(common, 'common.ConcurrentUsageExceededFault', {})
        ], ConcurrentUsageExceededFault);
        return ConcurrentUsageExceededFault;
    }(common.CommonClientFault));
    common.ConcurrentUsageExceededFault = ConcurrentUsageExceededFault;
})(common || (common = {}));
(function (common) {
    var InvalidIdSyntaxFault = /** @class */ (function (_super) {
        __extends(InvalidIdSyntaxFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidIdSyntaxFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidIdSyntaxFault = __decorate([
            osa.decorators.ComplexType(common, 'common.InvalidIdSyntaxFault', {
                'Id': { n: 'id', r: 'common.CommonId', r2: function () { return common.CommonId; }, f: 1 },
                'CorrectSyntax': { n: 'correctSyntax', t: 2 }
            })
        ], InvalidIdSyntaxFault);
        return InvalidIdSyntaxFault;
    }(common.CommonClientFault));
    common.InvalidIdSyntaxFault = InvalidIdSyntaxFault;
})(common || (common = {}));
(function (common) {
    var InvalidProductFault = /** @class */ (function (_super) {
        __extends(InvalidProductFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidProductFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidProductFault = __decorate([
            osa.decorators.ComplexType(common, 'common.InvalidProductFault', {
                'AvailableProducts': { n: 'availableProducts', r: 'common.ProductInfo', r2: function () { return common.ProductInfo; }, f: 5 }
            })
        ], InvalidProductFault);
        return InvalidProductFault;
    }(common.CommonClientFault));
    common.InvalidProductFault = InvalidProductFault;
})(common || (common = {}));
(function (common) {
    var InvalidSessionFault = /** @class */ (function (_super) {
        __extends(InvalidSessionFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidSessionFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidSessionFault = __decorate([
            osa.decorators.ComplexType(common, 'common.InvalidSessionFault', {})
        ], InvalidSessionFault);
        return InvalidSessionFault;
    }(common.CommonClientFault));
    common.InvalidSessionFault = InvalidSessionFault;
})(common || (common = {}));
(function (common) {
    var InvalidFilterSyntaxFault = /** @class */ (function (_super) {
        __extends(InvalidFilterSyntaxFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidFilterSyntaxFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidFilterSyntaxFault = __decorate([
            osa.decorators.ComplexType(common, 'common.InvalidFilterSyntaxFault', {
                'RequestedFilter': { n: 'requestedFilter', t: 2 },
                'CorrectFilterSyntax': { n: 'correctFilterSyntax', t: 2 }
            })
        ], InvalidFilterSyntaxFault);
        return InvalidFilterSyntaxFault;
    }(common.CommonClientFault));
    common.InvalidFilterSyntaxFault = InvalidFilterSyntaxFault;
})(common || (common = {}));
(function (common) {
    var InvalidUserFault = /** @class */ (function (_super) {
        __extends(InvalidUserFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidUserFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidUserFault = __decorate([
            osa.decorators.ComplexType(common, 'common.InvalidUserFault', {})
        ], InvalidUserFault);
        return InvalidUserFault;
    }(common.CommonClientFault));
    common.InvalidUserFault = InvalidUserFault;
})(common || (common = {}));
(function (common) {
    var MissingProductFault = /** @class */ (function (_super) {
        __extends(MissingProductFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function MissingProductFault(data) {
            return _super.call(this, data) || this;
        }
        MissingProductFault = __decorate([
            osa.decorators.ComplexType(common, 'common.MissingProductFault', {
                'AvailableProducts': { n: 'availableProducts', r: 'common.ProductInfo', r2: function () { return common.ProductInfo; }, f: 5 }
            })
        ], MissingProductFault);
        return MissingProductFault;
    }(common.CommonClientFault));
    common.MissingProductFault = MissingProductFault;
})(common || (common = {}));
(function (common) {
    var NotImplementedFault = /** @class */ (function (_super) {
        __extends(NotImplementedFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function NotImplementedFault(data) {
            return _super.call(this, data) || this;
        }
        NotImplementedFault = __decorate([
            osa.decorators.ComplexType(common, 'common.NotImplementedFault', {})
        ], NotImplementedFault);
        return NotImplementedFault;
    }(common.CommonClientFault));
    common.NotImplementedFault = NotImplementedFault;
})(common || (common = {}));
(function (common) {
    var SessionExpiredFault = /** @class */ (function (_super) {
        __extends(SessionExpiredFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function SessionExpiredFault(data) {
            return _super.call(this, data) || this;
        }
        SessionExpiredFault = __decorate([
            osa.decorators.ComplexType(common, 'common.SessionExpiredFault', {})
        ], SessionExpiredFault);
        return SessionExpiredFault;
    }(common.CommonClientFault));
    common.SessionExpiredFault = SessionExpiredFault;
})(common || (common = {}));
(function (common) {
    var AccessDeniedFault = /** @class */ (function (_super) {
        __extends(AccessDeniedFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function AccessDeniedFault(data) {
            return _super.call(this, data) || this;
        }
        AccessDeniedFault = __decorate([
            osa.decorators.ComplexType(common, 'common.AccessDeniedFault', {})
        ], AccessDeniedFault);
        return AccessDeniedFault;
    }(common.CommonClientFault));
    common.AccessDeniedFault = AccessDeniedFault;
})(common || (common = {}));
(function (common) {
    var UnauthenticatedFault = /** @class */ (function (_super) {
        __extends(UnauthenticatedFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function UnauthenticatedFault(data) {
            return _super.call(this, data) || this;
        }
        UnauthenticatedFault = __decorate([
            osa.decorators.ComplexType(common, 'common.UnauthenticatedFault', {})
        ], UnauthenticatedFault);
        return UnauthenticatedFault;
    }(common.CommonClientFault));
    common.UnauthenticatedFault = UnauthenticatedFault;
})(common || (common = {}));
(function (common) {
    var UncategorizedCommonClientFault = /** @class */ (function (_super) {
        __extends(UncategorizedCommonClientFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function UncategorizedCommonClientFault(data) {
            return _super.call(this, data) || this;
        }
        UncategorizedCommonClientFault = __decorate([
            osa.decorators.ComplexType(common, 'common.UncategorizedCommonClientFault', {})
        ], UncategorizedCommonClientFault);
        return UncategorizedCommonClientFault;
    }(common.CommonClientFault));
    common.UncategorizedCommonClientFault = UncategorizedCommonClientFault;
})(common || (common = {}));
(function (common) {
    var ImplementationValidationFault = /** @class */ (function (_super) {
        __extends(ImplementationValidationFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function ImplementationValidationFault(data) {
            return _super.call(this, data) || this;
        }
        ImplementationValidationFault = __decorate([
            osa.decorators.ComplexType(common, 'common.ImplementationValidationFault', {})
        ], ImplementationValidationFault);
        return ImplementationValidationFault;
    }(common.ValidationFault));
    common.ImplementationValidationFault = ImplementationValidationFault;
})(common || (common = {}));
module.exports = common;
// end of file
//# sourceMappingURL=index.js.map